import { useScript } from 'hooks';
export const HubSpotTracking = ({ hubSpot }) => {
    const src = hubSpot && hubSpot.id
        ? `//js.hs-scripts.com/${hubSpot.id}.js?businessUnitId=${hubSpot.businessUnitId}`
        : '';
    useScript(src, true);
    return null;
};
export default HubSpotTracking;
